export default __webpack_public_path__ + "static/python-course-overview-6461cee7fbf7b2174608fef01dfe78e8.webp";